/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/ctm'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import CtmLanding from '@routes/Ctm';

export const Route = createFileRoute('/ctm')({
  staticData: { layout: { landingFooter: true } },
  component: () => (
    <CacheDataRoute component={CtmLanding} path='/ctm' />
  )
});
